export default {
    name: 'ILayoutFooter'
};
